(function($){
    var $fn = $(".comp_subpage_head");

    if($fn.length) {
        var $capacity = $fn.find("[data-capacity]");

        if($capacity.length) {
            $.getScript("https://cdnjs.cloudflare.com/ajax/libs/progressbar.js/1.0.1/progressbar.min.js").done(function () {
                $capacity.each(function () {
                    var $this = $(this),
                        $max = $this.data("max"),
                        $current = $this.data("capacity"),
                        $radial = $this.find(".elm_radial"),
                        $id = $radial.attr('id'),
                        $bar_color = ($radial.hasClass("mod--red"))?"#f52f59":($radial.hasClass("mod--blue"))?"#009bd9":($radial.hasClass("mod--green"))?"#26a65b":"#ffd400";

                    var bar = new ProgressBar.Circle("#"+$id, {
                        strokeWidth: 6,
                        easing: 'easeInOut',
                        duration: 1500,
                        color: $bar_color,
                        trailColor: '#e6e6e6',
                        trailWidth: 6,
                        svgStyle: null,
                        text: {
                            autoStyleContainer: false
                        },
                        step: function(state, circle) {
                            var value = Math.round(circle.value()*$max);
                            if (value === 0) {
                                circle.setText("<strong>"+0+"</strong>/"+$max);
                            } else {
                                circle.setText("<strong>"+value+"</strong>/"+$max);
                            }
                        }
                    });

                    bar.text.style.fontSize = '1.2em';
                    bar.text.style.color = '#4c4c4c';
                    bar.text.style.fontWeight = '300';

                    var $progress = Math.min($current / $max,1);

                    bar.animate($progress);  // Number from 0.0 to 1.0
                });
            })
        }
    }
})(jQuery);